import { MuiRootProps } from "types/mui"
import { LakeBlue, Midnight } from "./colours"

/**
 * - Styles override to MUICheckbox to match Vacasa owner onboarding design
 */
const muiCheckbox = {
    styleOverrides: {
        root: ({ theme }: MuiRootProps) => ({
            borderRadius: "3px",
            height: theme.spacing(2),
            width: theme.spacing(2),
            color: Midnight[40],
            padding: "none",
            "&.Mui-checked": {
                color: LakeBlue[100],
            },
        }),
    },
}

export default muiCheckbox
